'use strict';
const sortedSubIdeas = require('./sorted-sub-ideas'),
	traverse = require('./traverse');
module.exports = function ClipboardConverter(nativeMimeType, parsers) {
	const self = this,
		textMimeType = 'text/plain',
		htmlMimeType = 'text/html',
		toText = function (ideas) {
			let rootLevel;
			const contents = [],
				pushText = function (idea, level) {
					let indent = '';
					if (!rootLevel) {
						rootLevel = level;
					} else {
						indent = new Array(level - rootLevel + 1).join('\t');
					}
					if (idea.title) {
						contents.push(indent + idea.title.replace(/\n+/g, ' '));
					}
				};
			ideas.forEach((i) => {
				rootLevel = false;
				traverse(i, pushText);
			});
			return contents.join('\n');
		},
		ideaToHtml = function (idea) {
			const components = [],
				subIdeas = sortedSubIdeas(idea);
			components.push('<li>');
			if (idea.title) {
				components.push('<span>');
				components.push(idea.title.replace(/\n/g, '<br/>'));
				components.push('</span>');
			}
			if (subIdeas.length > 0) {
				components.push('<ul>');
				subIdeas.forEach(sub => components.push(ideaToHtml(sub)));
				components.push('</ul>');
			}
			components.push('</li>');
			return components.join('');
		},
		toHtml = function (ideas) {
			return '<html><meta></meta><body><ul>' +
				ideas.map(ideaToHtml).join('') +
				'</ul></body></html>';
		},
		deserializeNativeMimeType = clipboardData => {
			const clipboardString = clipboardData.getData(nativeMimeType);
			return JSON.parse(clipboardString);
		};

	self.getNativeContentType = function () {
		return nativeMimeType;
	};
	self.serialize = function (clipboardArray, mimeType) {
		if (mimeType === nativeMimeType) {
			return JSON.stringify(clipboardArray);
		}
		if (mimeType === textMimeType) {
			return toText(clipboardArray);
		}
		if (mimeType === htmlMimeType) {
			return toHtml(clipboardArray);
		}
	};
	self.deserialize = function (clipboardData) {
		const tryParsing = function (contentType) {
			return clipboardData.types.includes(contentType)
				&& parsers[contentType]
				&& parsers[contentType](clipboardData.getData(contentType));
		};
		if (clipboardData.types.includes(nativeMimeType)) {
			return deserializeNativeMimeType(clipboardData);
		}
		return tryParsing('text/html') || tryParsing('text/plain');
	};
};
